import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Thunk for getting home banners
export const getColours = createAsyncThunk(
  "colours/colour",
  async (_, { rejectWithValue }) => {
    try {
      const bannerData = await GET(API.GET_COLOURS);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getPolish = createAsyncThunk(
  "colours/polish",
  async (_, { rejectWithValue }) => {
    try {
      const bannerData = await GET(API.GET_POLISH);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


export const getSizes = createAsyncThunk(
  "colours/size",
  async (_, { rejectWithValue }) => {
    try {
      const bannerData = await GET(API.GET_SIZE);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getShape = createAsyncThunk(
  "colours/shape",
  async (_, { rejectWithValue }) => {
    try {
      const bannerData = await GET(API.GET_SHAPE);
      return bannerData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const colourSlice = createSlice({
  name: "colours",
  initialState: {
    name: "",
    image: "",
    colour: [],
    polish: [],
    size: [],
    shapes: [],
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getColours.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getColours.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.colour = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getColours.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })



      .addCase(getPolish.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getPolish.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.polish = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getPolish.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })




      .addCase(getSizes.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getSizes.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.size = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getSizes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

       .addCase(getShape.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getShape.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.shapes = action.payload?.data || [];
        console.log("State after fulfilled", state);
      })
      .addCase(getShape.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      });
  },
});

export default colourSlice.reducer;
